<template>
  <div>
    <b-table
        head-row-variant="info"
        table-variant="white"
        show-empty
        :items="announcementList"
        :fields="announcementListHeaders"
        hover
        responsive
        sort-icon-left
        :busy="announcementListLoading"

    >
      <template #empty="scope">
        <h6 class="text-center my-5">
          {{ scope.loading ? "Lütfen Bekleyin" : errorMessageAll ? errorMessageAll : "Veri Bulunamadı" }}
        </h6>
      </template>
      <template #table-busy>
        <div class="text-center">
          <b-spinner
              variant="primary"
              size="lg"
              label="Lütfen Bekleyin..."
          ></b-spinner>
        </div>
      </template>
      <template #cell(process)="data">
        <div class="text-center" v-if="!data.item.status">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="amber darken-2"
                  @click="openAnnouncementDialog(data.item)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Düzenle</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="danger darken-2" @click="announcementDelete({
                  params:{
                    announcementId : data.item.id
                  }
                })">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span>Sil</span>
          </v-tooltip>
        </div>
      </template>
      <template #cell(startDate)="data">
        {{ formattedDate(data.item.startDate, "DD MMMM YYYY") }}
      </template>
      <template #cell(finishDate)="data">
        {{ formattedDate(data.item.finishDate, "DD MMMM YYYY") }}
      </template>
    </b-table>
    <EditAnnouncementDialog
        :announcementProp="announcement"
        :processType="'edit'"
        :showDialog="editAnnouncementDialog"
        @dialogChange="(data) => (editAnnouncementDialog = data)"
    ></EditAnnouncementDialog>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

import EditAnnouncementDialog from '@/components/management/announcement/dialogs/EditAnnouncementDialog.vue'
import {formattedDate} from "@/momentHelper";


export default {
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },

  components: {
    EditAnnouncementDialog
  },

  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("announcement", ["announcementList", "announcementListHeaders", "announcementListLoading"])
  },
  mounted() {

  },
  data() {
    return {
      selectRow: false,
      userData: null,
      editAnnouncementDialog: false,
      announcement: null
    };
  },
  methods: {
    formattedDate,
    ...mapActions("announcement", ["announcementDelete"]),
    async openAnnouncementDialog(data) {
      this.announcement = data;
      this.editAnnouncementDialog = true;
    }
  },
  watch: {
    "editAnnouncementDialog": function (newVal) {
      if (!newVal)
        this.announcement = null;
    }

  },
};
</script>
